// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var IndicatorGroups;
(function (IndicatorGroups) {
    IndicatorGroups["MovingAverage"] = "Moving Average";
    IndicatorGroups["Oscillators"] = "Oscillators";
    IndicatorGroups["Channels"] = "Channels";
    IndicatorGroups["Volume"] = "Volume";
    IndicatorGroups["Trend"] = "Trend";
    IndicatorGroups["Volatility"] = "Volatility";
    IndicatorGroups["Extra"] = "Extra";
    IndicatorGroups["Custom"] = "Custom";
})(IndicatorGroups || (IndicatorGroups = {}));
